import React from "react";
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";

export interface BaseDialogProps extends React.PropsWithChildren {
    open: boolean;
    onClose: (value: boolean) => void;
    title?: React.ReactNode;
    
    sizeClass?: string;
    closeOnOutsideClick?: boolean;
}

const BaseDialog: React.FC<BaseDialogProps> = ({open, onClose, title, children, sizeClass, closeOnOutsideClick = true}) => (
    <Dialog open={open} onClose={closeOnOutsideClick ? onClose : () => undefined} className='relative z-13' >
        <DialogBackdrop transition
            className='fixed inset-0 bg-gray-500/75 transition-opacity
            data-enter:duration-300 data-enter:ease-out
            data-leave:duration-200 data-leave:ease-in
            data-closed:opacity-0'/>
        <div className='fixed inset-0 w-screen overflow-y-hidden flex min-h-full items-center justify-center'>
            <DialogPanel transition
                         className={`relative flex flex-col overflow-visible rounded-lg bg-white p-4 shadow-xl w-full dialog-panel-transition
                         data-closed:translate-y-6 data-closed:opacity-0 ${sizeClass ?? 'max-w-lg'}`}>
                {title &&
                    <DialogTitle as='h3' className='text-base font-semibold text-gray-900'>
                        {title}
                    </DialogTitle>
                }

                {children}
            </DialogPanel>
        </div>
    </Dialog>
);

export default BaseDialog;